module.exports = __webpack_public_path__ + "images/search-deal-icon.png";